import { render, staticRenderFns } from "./statistical.vue?vue&type=template&id=e09fc7fe&scoped=true&"
import script from "./statistical.vue?vue&type=script&lang=js&"
export * from "./statistical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09fc7fe",
  null
  
)

export default component.exports